var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.01428 19.8571V1","stroke":"#1E3D7C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.01429 19.8572L1 11.8429","stroke":"#1E3D7C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M17.5 11.3715L9.48572 19.3857","stroke":"#1E3D7C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

DownArrow.defaultProps = {"width":"19","height":"21","viewBox":"0 0 19 21","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
